<cac-dialog-layout [title]="data.coupon ? 'Edit Coupon Code' : 'Add New Coupon Code'"
  subtitle="Enter the required data and save" (onSubmit)="onSubmit($event)" [form]="form" [hideControls]="false">
  <div class="p-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <!-- Basic Information -->
      <cac-field [control]="form.controls.name" label="Name" controlType="input" class="col-span-1" />
      <cac-field [control]="form.controls.code" label="Code" controlType="input" class="col-span-1" />
      <cac-field [control]="form.controls.expirationDate" label="Expiration Date" controlType="date" [clearable]="true"
        class="col-span-1" />

      <cac-field [control]="form.controls.usageLimitation" label="Usage Limitation (Optional)" controlType="input"
        inputType="number" class="col-span-1" />

      <!-- Discount For -->
      <cac-field [control]="form.controls.discountFor" label="Discount For" controlType="select"
        [items]="discountForItems" [multiple]="true" class="col-span-2" />

      <!-- Target Selection Fields (conditionally shown) -->
      @if (shouldShowTargetField(TargetType.Product)) {
      <div class="col-span-2 mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-2">Select Products</label>
        <app-lazy-dropdown
          [multiple]="true"
          [searchable]="true"
          [clearable]="true"
          placeholder="Select products..."
          [initialIds]="form.controls.productIds.value || []"
          [apiAdapter]="productApiAdapter"
          [itemMapper]="productItemMapper"
          idsFilterKey="ProductIds"
          searchField="EnglishName"
          duplicateMessage="Product is already selected"
          [showCustomTemplate]="true"
          (selectionChange)="onProductSelectionChange($event)" />
      </div>
      }

      @if (shouldShowTargetField(TargetType.Vendor)) {
      <cac-field [control]="form.controls.vendorIds" label="Select Vendors" controlType="select" [items]="vendorItems$"
        [multiple]="true" [searchable]="true" class="col-span-2" />
      }

      @if (shouldShowTargetField(TargetType.Category)) {
      <cac-field [control]="form.controls.categoryIds" label="Select Categories" controlType="select"
        [items]="categoryItems$" [multiple]="true" [searchable]="true" class="col-span-2" />
      }

      @if (shouldShowTargetField(TargetType.Customer)) {
      <div class="col-span-2 mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-2">Select Customers</label>
        <app-lazy-dropdown
          [multiple]="true"
          [searchable]="true"
          [clearable]="true"
          placeholder="Select customers..."
          [initialIds]="form.controls.customerIds.value || []"
          [apiAdapter]="customerApiAdapter"
          [itemMapper]="customerItemMapper"
          idsFilterKey="CustomerIds"
          searchField="email"
          duplicateMessage="Customer is already selected"
          (selectionChange)="onCustomerSelectionChange($event)" />
      </div>
      }

      @if (shouldShowDiscountFields()) {
      <cac-field [control]="form.controls.type" label="Type" controlType="select" [items]="couponTypeItems"
        class="col-span-1" />

      <cac-field [control]="form.controls.discountAmount" label="Discount Amount" controlType="input" inputType="number"
        [suffix]="form.controls.type.value === 1 ? '%' : 'KWD'" class="col-span-1" />
      }

      <!-- Shipping Discount -->
      <cac-switch [control]="form.controls.hasShippingDiscount" label="Shipping Discount" class="col-span-2" />

      @if (shouldShowShippingDiscountAmount()) {
      <cac-field [control]="form.controls.shippingDiscountAmount" label="Shipping Discount Amount (KWD)"
        controlType="input" inputType="number" class="col-span-1" />
      }

      <!-- Apply on Discounted Products -->
      <cac-switch [control]="form.controls.applyOnDiscountedProducts" label="Apply on Discounted Products" class="col-span-2" />

    </div>
  </div>
</cac-dialog-layout>